import { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import "./homeFooter.css";

// Existing Terms of Service & Privacy Policy document used by the legacy footer.
const LEGAL_PDF_URL =
  "https://amplify-gameupdev-staging-212044-deployment.s3.amazonaws.com/Terms%2Bof%2BService%2B%26%2BPrivacy%2BPolicy-Game-Up.pdf";

const SOCIAL_LINKS = {
  instagram: "https://instagram.com/GameUp.nyc",
  facebook: "https://www.facebook.com/profile.php?id=61557750935893",
  linkedin: "https://www.linkedin.com/company/joingameup/",
};

const ELFSIGHT_SCRIPT_SRC = "https://elfsightcdn.com/platform.js";

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 1.62c-3.15 0-3.52.01-4.76.07-1.15.05-1.77.24-2.19.41-.55.21-.94.47-1.35.88-.41.41-.67.8-.88 1.35-.17.42-.36 1.04-.41 2.19-.06 1.24-.07 1.61-.07 4.76s.01 3.52.07 4.76c.05 1.15.24 1.77.41 2.19.21.55.47.94.88 1.35.41.41.8.67 1.35.88.42.17 1.04.36 2.19.41 1.24.06 1.61.07 4.76.07s3.52-.01 4.76-.07c1.15-.05 1.77-.24 2.19-.41.55-.21.94-.47 1.35-.88.41-.41.67-.8.88-1.35.17-.42.36-1.04.41-2.19.06-1.24.07-1.61.07-4.76s-.01-3.52-.07-4.76c-.05-1.15-.24-1.77-.41-2.19a3.64 3.64 0 0 0-.88-1.35 3.64 3.64 0 0 0-1.35-.88c-.42-.17-1.04-.36-2.19-.41-1.24-.06-1.61-.07-4.76-.07Zm0 2.76a5.46 5.46 0 1 1 0 10.92 5.46 5.46 0 0 1 0-10.92Zm0 9a3.54 3.54 0 1 0 0-7.08 3.54 3.54 0 0 0 0 7.08Zm6.95-9.22a1.27 1.27 0 1 1-2.55 0 1.27 1.27 0 0 1 2.55 0Z"
    />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.88h2.78l-.44 2.91h-2.34V22c4.78-.76 8.44-4.92 8.44-9.94Z"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28ZM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14Zm1.78 13.02H3.56V9h3.56v11.45ZM22.22 0H1.77C.8 0 0 .78 0 1.74v20.51C0 23.22.8 24 1.77 24h20.45c.98 0 1.78-.78 1.78-1.75V1.74C24 .78 23.2 0 22.22 0Z"
    />
  </svg>
);

const FOLLOW_ITEMS = [
  { key: "instagram", href: SOCIAL_LINKS.instagram, label: "GameUp.nyc", Icon: InstagramIcon },
  { key: "facebook", href: SOCIAL_LINKS.facebook, label: "GameUp", Icon: FacebookIcon },
  { key: "linkedin", href: SOCIAL_LINKS.linkedin, label: "GameUp", Icon: LinkedInIcon },
];

export default function HomeFooter() {
  const instaRef = useRef(null);

  // Load the Elfsight platform script once. This site is CRA (not Next), so we
  // inject the script via an effect instead of a raw <script> tag in JSX.
  useEffect(() => {
    if (document.querySelector(`script[src="${ELFSIGHT_SCRIPT_SRC}"]`)) {
      return;
    }
    const script = document.createElement("script");
    script.src = ELFSIGHT_SCRIPT_SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // Robust "Load more" hide. The CSS also hides it, but Elfsight's class names
  // vary between widget versions, so this is a JS backstop. It is scoped
  // strictly to the Instagram feed section (instaRef) and the widget renders in
  // the light DOM, so it can never hide buttons elsewhere on the site. The feed
  // mounts asynchronously, so we re-run on every mutation inside the section.
  useEffect(() => {
    const root = instaRef.current;
    if (!root) return;

    const hideLoadMore = () => {
      root
        .querySelectorAll(
          '[class*="load-more" i],[class*="loadmore" i],[class*="show-more" i],[class*="showmore" i]'
        )
        .forEach((el) => el.style.setProperty("display", "none", "important"));

      root.querySelectorAll("a,button").forEach((el) => {
        const text = (el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        if (
          text === "load more" ||
          text === "load more..." ||
          text === "load more…" ||
          text === "show more"
        ) {
          el.style.setProperty("display", "none", "important");
        }
      });
    };

    hideLoadMore();
    const observer = new MutationObserver(hideLoadMore);
    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <footer className="home-footer">
      {/* Full-bleed Instagram strip + right-side FOLLOW US panel */}
      <section
        className="home-footer__insta"
        aria-label="GameUp on Instagram"
        ref={instaRef}
      >
        <div className="home-footer__feed">
          <div
            className="elfsight-app-b76e5dc8-4ce5-4f43-a46a-a7236ec203ef"
            data-elfsight-app-lazy
          ></div>
        </div>

        <aside className="home-footer__follow" aria-label="Follow GameUp">
          <h3 className="home-footer__follow-title">Follow Us</h3>
          {FOLLOW_ITEMS.map(({ key, href, label, Icon }) => (
            <a
              key={key}
              className="home-footer__follow-link"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="home-footer__follow-badge">
                <Icon />
              </span>
              <span>{label}</span>
            </a>
          ))}
        </aside>
      </section>

      {/* Dark footer body: logo (left) | nav (center) | social (right) */}
      <div className="home-footer__main">
        <Container>
          <div className="home-footer__grid">
            <div className="home-footer__brand">
              <img
                src="/gameup-footer-logo.png"
                alt="GameUp"
                className="home-footer__logo"
              />
            </div>

            <nav className="home-footer__nav" aria-label="Footer">
              <div className="home-footer__nav-col">
                <Link to="/search-landing">Search Directory</Link>
                <Link to="/chatbot">Chat</Link>
                <Link to="/joingame">Team Registration</Link>
              </div>
              <div className="home-footer__nav-col">
                <Link to="/about">About Us</Link>
                <Link to="/basketball-concierge">Contact</Link>
              </div>
            </nav>

            <div className="home-footer__social">
              <h4 className="home-footer__social-title">Follow Us</h4>
              <div className="home-footer__social-icons">
                <a
                  href={SOCIAL_LINKS.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GameUp on Instagram"
                >
                  <InstagramIcon />
                </a>
                <a
                  href={SOCIAL_LINKS.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GameUp on Facebook"
                >
                  <FacebookIcon />
                </a>
                <a
                  href={SOCIAL_LINKS.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GameUp on LinkedIn"
                >
                  <LinkedInIcon />
                </a>
              </div>
            </div>
          </div>
        </Container>
      </div>

      {/* Bottom legal row */}
      <div className="home-footer__bottom">
        <Container>
          <div className="home-footer__bottom-row">
            <p className="home-footer__copyright">
              © 2026 GameUp. All rights reserved.
            </p>
            <div className="home-footer__legal">
              <a href={LEGAL_PDF_URL} target="_blank" rel="noopener noreferrer">
                Privacy
              </a>
              <a href={LEGAL_PDF_URL} target="_blank" rel="noopener noreferrer">
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
}
